import React from 'react';
import { g_Auth } from '../apis/apiAuth';
import ApiUsers from '../apis/apiUsers';
import { jwtDecode } from 'jwt-decode';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { g_HttpReq } from '../utils/httpUtils';

// ////////////////////////////////////////////////////////////////////////////////////////////////
const userInitialState = {
  // first 3 used key
  entityId: '',
  parentOrgId: '',
  token: '',
  userRoles: ['User'],
  email: '',
  firstName: '',
  lastName: '',
  photo: '',
  loginDate: '',
  tokenInfo: {},
};

// ////////////////////////////////////////////////////////////////////////////////////////////////
export const updateUserTokenAsync = createAsyncThunk('user/updateUserTokenAsync', async (token, { dispatch, rejectWithValue }) => {
  try {
    if (token) {
      console.warn('updateUserTokenAsync token');
      g_HttpReq.setAccessToken(token);
    }
    const tokenJson = jwtDecode(token);
    if (!tokenJson || !tokenJson.userId) {
      const errMsg = `Invalid token [${token}]`;
      console.warn(errMsg);
      return rejectWithValue({ status: 400, statusText: errMsg });
    }
    const { iat, exp, ...rest } = tokenJson;
    // const extTmoMsec = (tokenJson.exp - tokenJson.iat) * 1000;
    await g_Auth.setToken(token, tokenJson.parentOrgId);
    const user = await ApiUsers.apiUserGet(tokenJson.userId);
    if (!user || !user.user) {
      console.warn('updateUserTokenAsync invalid user data', user);
      return rejectWithValue('Invalid user data');
    }
    // setTimeout(refreshAccessToken, extTmoMsec / 2, dispatch);
    dispatch({ type: 'userTkn/update', organization: user.organization });
    return { ...user.user, token, tokenInfo: rest };
  } catch (err) {
    console.warn('updateUserTokenAsync invalid token received', err);
    return rejectWithValue(err);
  }
});

// ////////////////////////////////////////////////////////////////////////////////////////////////
export const logoutUserAsync = createAsyncThunk('user/logoutUserAsync', async (_, { dispatch }) => {
  try {
    // await g_Auth.authLogout();
    g_HttpReq.setAccessToken(null);
    g_Auth.setToken(userInitialState.token, userInitialState.parentOrgId);
    return;
  } catch (err) {
    console.error('Logout failed', err);
  }
});

const userSlice = createSlice({
  name: 'user',
  initialState: userInitialState,
  reducers: {
    update: (state, action) => {
      const { type, ...rest } = action; // eslint-disable-line
      console.log('userSlice update', state, action, rest);
      Object.assign(state, rest);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateUserTokenAsync.pending, (state) => {
      // console.log('updateUserTokenAsync.pending', state);
    });
    builder.addCase(updateUserTokenAsync.fulfilled, (state, action) => {
      // console.warn('updateUserTokenAsync.fulfilled', state, action);
      Object.assign(state, action.payload);
    });
    builder.addCase(updateUserTokenAsync.rejected, (state, action) => {
      console.log('updateUserTokenAsync.rejected', state, action);
    });
    builder.addCase(logoutUserAsync.fulfilled, (state, action) => {
      console.log('logoutUserAsync.fulfilled', state, action);
      Object.assign(state, userInitialState);
    });
  },
});

export default userSlice.reducer;
